// calling both current and archived teacher
export const START_FETCH_CLIENT_LIST = 'START_FETCH_CLIENT_LIST'
export const SUCCESS_FETCH_CLIENT_LIST = 'SUCCESS_FETCH_CLIENT_LIST'
export const FAILED_FETCH_CLIENT_LIST = 'FAILED_FETCH_CLIENT_LIST'

export const START_DELETE_CLIENT_TAG = 'START_DELETE_CLIENT_TAG'
export const SUCCESS_DELETE_CLIENT_TAG = 'SUCCESS_DELETE_CLIENT_TAG'

export const START_EDIT_CLIENT_TAG = 'START_EDIT_CLIENT_TAG'
export const SUCCESS_EDIT_CLIENT_TAG = 'SUCCESS_EDIT_CLIENT_TAG'

import getClientList from 'controllers/client/getClientList'
import deleteClientTagCTRL from 'controllers/client/deleteClientTag'
import editClientTagCTRL from 'controllers/client/editClientTag'

import alert from 'util/alert';
import without from 'lodash/without'

export const DEFAULT_PAGINATION = {
  activePage: 0,
  itemsCountPerPage: 10,
  totalItemsCount: 0,
}

export function fetchClientList(obj){

  return function(dispatch) {
    dispatch({
      type: START_FETCH_CLIENT_LIST,
      payload: {
        fetching: true,
      }
    })

    getClientList(obj)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_CLIENT_LIST,
        payload: {...result, fetching: false, amount_per_page: obj.amount_per_page, hasPermission: true}
      })
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_CLIENT_LIST,
        payload: {err, fetching: false, hasPermission: false}
      })
    })
  }
}

export function deleteClientTag(index, tagId, tagName){
  return function(dispatch) {
    dispatch({
      type: START_DELETE_CLIENT_TAG,
      payload: {
        index,
        tagName,
        tagId,
      }
    })

    deleteClientTagCTRL(tagId)
    .then((result) => {
      dispatch({
        type: SUCCESS_DELETE_CLIENT_TAG,
        payload: {...result}
      })
    })
    .catch((err)  => {
      alert.error('API CALL FAILED: Net error')
      .then(() => {window.location.reload();})
    })
  }
}

export function editClientTag(index, tagId, oldTagName, tagName, callback){
  return function(dispatch) {
    dispatch({
      type: START_EDIT_CLIENT_TAG,
    })

    editClientTagCTRL(tagId, tagName)
    .then((result) => {
      dispatch({
        type: SUCCESS_EDIT_CLIENT_TAG,
        payload: {...result, index, tagId, oldTagName, tagName}
      })

      if(typeof(callback) == 'function'){
        callback()
      }

    })
    .catch((err)  => {
      alert.error('API CALL FAILED: Net error')
      .then(() => {window.location.reload()})
    })
  }
}


const initState = {
  list: [],
  tag_list: [],
  pagination: DEFAULT_PAGINATION,
  fetching: false,
}

export default function clientList(state = initState, action){
  switch(action.type){
    case START_FETCH_CLIENT_LIST: {
      return {...state, fetching: true}
    }
    case SUCCESS_FETCH_CLIENT_LIST: {
      const {
        result_list,
        fetching,
        tag_filter_list,
        amount_per_page,
        current_page_number,
        total_amount,
        hasPermission,
        school_has_contact
      } = action.payload

      return {
        ...state,
        list: result_list,
        tag_list: tag_filter_list,
        fetching: false,
        hasPermission,
        school_has_contact,
        pagination: {
          itemsCountPerPage: amount_per_page,
          activePage: current_page_number,
          totalItemsCount: total_amount,
        }
      }
    }
    case FAILED_FETCH_CLIENT_LIST: {
      return {...state, err: action.payload.err, fetching: false, hasPermission: action.payload.hasPermission}
    }

    // delete tag
    case START_DELETE_CLIENT_TAG: {

      let newList = state.list
      newList.map((item) => {
        item.tag_name_list.map((name) => {
          if (name == action.payload.tagName){
            item.tag_name_list = without(item.tag_name_list, name)
          }
        })
      })

      return {
        ...state,
        list: newList,
        tag_list: [
          ...state.tag_list.slice(0, action.payload.index),
          ...state.tag_list.slice(action.payload.index + 1)
        ]
      }
    }

    // edit tag
    case SUCCESS_EDIT_CLIENT_TAG: {
      const {index, oldTagName, tagName, tagId} = action.payload;

      let newList = state.list
      let i;
      newList.map((item) => {
        item.tag_name_list.map((n) => {
          if (n == oldTagName){
            i = item.tag_name_list.indexOf(n)
            item.tag_name_list[i] = tagName.tag_name
          }
        })
      })

      let name = {name: tagName.tag_name}
      return {
        ...state,
        list: newList,
        tag_list: state.tag_list.map((existing, i)=>{
          return index === i ? { ...existing, ...name } : existing;
        })
      }
    }

    default: return {...state}
  }
}

//



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClient/ducks.js